import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default function Location(props) {
  // State لحفظ الموقع والحالة
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [status, setStatus] = useState(true); // رسالة الحالة
  const [loading, setLoading] = useState(false); // لإظهار التحميل
  // دالة للحصول على الموقع
  const handleGetLocation = () => {
    setLoading(true); // ابدأ التحميل
    setStatus(''); // امسح الرسالة السابقة

    if (navigator.geolocation) { // تحقق من دعم المتصفح
      navigator.geolocation.getCurrentPosition(
        (position) => { // Callback للنجاح
          setLocation({
            latitude: position.coords.latitude,   // خط العرض
            longitude: position.coords.longitude,
          });
          props.location({
            latitude: position.coords.latitude,   // خط العرض
            longitude: position.coords.longitude,
          });
          setLoading(false); // انتهِ التحميل
          setStatus(false);
        },
        (error) => { 
  console.error("Geolocation Error Details:", error); // أضف هذا السطر
  setStatus('Error getting location: ' + error.message);
  setLoading(false);
},
        { // خيارات إضافية
          enableHighAccuracy: true, // دقة عالية
          timeout: 5000,          // مهلة 10 ثوانٍ
          maximumAge: 0,      // استخدم موقع مؤقت
        }
      );
    } else {
      setStatus('Geolocation is not supported by this browser.');
      setLoading(false);
    }
  };

  // إنشاء marker مخصص (نقطة على الخريطة)
  const defaultMarkerIcon = new L.Icon({
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
    shadowSize: [41, 41],
  });

  return (
    <div className='d-flex justify-content-start' style={{width:'100%'}} >
      {/* زر للحصول على الموقع */}
      {status && <button className="btn-order" onClick={handleGetLocation} disabled={loading}>
        {loading ? 'Getting Location...' : 'Get My Location'}
      </button>}
      
      {/* عرض الموقع بصيغة نصية */}
      {/* {location.latitude && location.longitude && (
        <div style={{ marginTop: '20px' }}>
          <p><strong>Latitude:</strong> {location.latitude}</p>
          <p><strong>Longitude:</strong> {location.longitude}</p>
        </div>
      )} */}
      
      {/* عرض الخريطة إذا تم الحصول على الموقع */}
      {location.latitude && location.longitude && (
        <div style={{ marginTop: '20px' , width:'100%' }}>
          <h3>Your Location on Map</h3>
          <MapContainer
            center={[location.latitude, location.longitude]} // مركز الخريطة
            zoom={13} // مستوى التكبير
            style={{ height: '400px', width: '100%' }} // حجم الخريطة
          >
            {/* طبقة الخريطة من OpenStreetMap */}
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; OpenStreetMap contributors'
            />
            
            {/* إضافة marker (علامة) على موقع المستخدم */}
            <Marker
              position={[location.latitude, location.longitude]}
              icon={defaultMarkerIcon} // استخدم الـ marker المخصص
            >
              <Popup>
                <div>
                  <p><strong>Your Location</strong></p>
                  <p>Latitude: {location.latitude.toFixed(6)}</p>
                  <p>Longitude: {location.longitude.toFixed(6)}</p>
                </div>
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      )}

    </div>
  );
}